import type { FetchedDocument } from "./fetchDocument";

const CACHE_MAX = 24;
const cache = new Map<string, FetchedDocument>();

function cloneFetchedDocument(doc: FetchedDocument): FetchedDocument {
  return { ...doc, buf: doc.buf.slice(0) };
}

export function documentCacheKey(url: string, sessionId?: string, adminToken?: string | null): string {
  const actor = sessionId ?? (adminToken ? `admin:${adminToken.slice(0, 16)}` : "admin-anon");
  return `${url}|${actor}`;
}

export function getCachedDocument(key: string): FetchedDocument | undefined {
  const hit = cache.get(key);
  return hit ? cloneFetchedDocument(hit) : undefined;
}

export function setCachedDocument(key: string, doc: FetchedDocument): void {
  const stored = cloneFetchedDocument(doc);
  if (cache.has(key)) {
    cache.delete(key);
  }
  cache.set(key, stored);
  while (cache.size > CACHE_MAX) {
    const oldest = cache.keys().next().value;
    if (!oldest) break;
    cache.delete(oldest);
  }
}

export function clearDocumentCache(): void {
  cache.clear();
  seenDocuments.clear();
}

/**
 * First-open registry (per tab session): the first preview of a document holds
 * the shield animation for a full fill cycle; repeat opens reveal instantly.
 */
const seenDocuments = new Set<string>();

export function hasSeenDocument(key: string): boolean {
  return seenDocuments.has(key);
}

export function markSeenDocument(key: string): void {
  seenDocuments.add(key);
}
